'use client'

import * as stylex from '@stylexjs/stylex'
import Link from 'next/link'
import { RefObject, createContext, useContext, useRef } from 'react'

type Context = {
  linkRef?: RefObject<HTMLAnchorElement | null>
}

export const LinkContext = createContext<Context>({})

interface LinkProviderProps {
  children: React.ReactNode
  styles?: stylex.StyleXStyles
}

export function LinkProvider(props: LinkProviderProps) {
  const linkRef = useRef<HTMLAnchorElement>(null)

  function clickHandler() {
    linkRef.current?.click()
  }

  return (
    <LinkContext.Provider value={{ linkRef }}>
      <li onClick={clickHandler} {...props} />
    </LinkContext.Provider>
  )
}

type ControlledLinkProps = React.ComponentProps<typeof Link>

export function ControlledLink(props: ControlledLinkProps) {
  const { linkRef } = useContext(LinkContext)
  return (
    <Link ref={linkRef} {...props}>
      {props.children}
    </Link>
  )
}
